<template>
    <ui-dialog
            :title="title"
            :isShow="isShowDalog"
            @closeDialog="closeDialog"
            @addOrEdit="submitForm"
    >
        <template #form>
            <el-form
                    ref="ruleFormRef"
                    :model="query"
                    :rules="rules"
                    label-width="80px"
            >
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="query.name" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="账号" prop="account">
                    <el-input v-model="query.account" placeholder="请输入账号" clearable></el-input>
                </el-form-item>
                <el-form-item label="部门" required>
                    <el-input v-model="query.departmentName" readonly placeholder="请选择部门">
                        <template #append>
                            <el-button type="primary" @click="selectParentEle">选择部门</el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="个性签名" prop="signature">
                    <el-input v-model="query.signature" placeholder="请输入个性签名" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="query.mobile" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="query.email" placeholder="请输入邮箱" clearable></el-input>
                </el-form-item>
                <el-drawer
                        size="420px"
                        v-model="isShowRight"
                        title="选择父级产品类型"
                        direction="rtl"
                        :before-close="closeRightHandle"
                        @opened="openedDrawer"
                >
                    <div>
                        <el-tree ref="getTreeRef" :current-node-key="data.id" highlight-current node-key="id" :data="data" default-expand-all :props="defaultProps" @node-click="handleNodeClick" />
                    </div>
                </el-drawer>
            </el-form>
        </template>
    </ui-dialog>
</template>

<script setup>
    import {
        defineComponent,
        onMounted,
        defineExpose,
        ref,
        computed,
        toRefs,
        reactive,
        defineProps,
        defineEmits,
        nextTick
    } from 'vue'
    import { ElMessage } from "element-plus"
    import {createHandle,updateHandle,detailHandle} from '@/api/employee'
    import {getProductList,createProTag,delProTagById,getProductTagTree,updateProTag} from '@/api/department'
    import {upload} from '@/api/upload'
    import ImageUploader from "quill-image-uploader";
    const props = defineProps({
        isShow:{
            type:Boolean
        },
        title:{
            type:String,
            default:"详情"
        },
    })
    const hideUpload = ref(false)
    const isShowDalog = ref(false)
    let query = reactive({
        id:undefined,
        name: "",
        account: "",
        departmentName: "",
        department_id:"",
        signature: [],
        email:'',
        mobile: "",
    })
    const rules = reactive({
        name: [
            {
                required: true,
                message: '请输入姓名',
                trigger: 'change',
            },
        ],
        account: [
            {
                required: true,
                message: '请输入账号',
                trigger: 'change',
            },
        ],
    })
    let isShowRight = ref(false)
    let getTreeRef = ref(null)
    const defaultProps = {
        children: 'children',
        label: 'name',
    }
    function selectParentEle(){
        isShowRight.value = true
    }
    function handleNodeClick(e){
        query.department_id = e.id
        query.departmentName = e.name
    }
    function closeRightHandle(){
        isShowRight.value = false
    }
    function openedDrawer(){
        getTreeRef.value.setCurrentKey(query.pid,true)
        nextTick(() => {
            getTreeRef.value.setCurrentKey(query.pid,true)
        })
    }
    let data = ref([])
    function getProductTagTreeHandle(){
        getProductTagTree().then(res=>{
            data.value = res.data
        })
    }
    const closeDialog = () => {
        emit("closeDialog")
    }
    const ruleFormRef = ref(null)
    const submitForm = () => {
        ruleFormRef.value.validate((valid) => {
            if (valid) {
                let params = query
                if(query.id){
                    updateForm(params)
                }else{
                    addForm(params)
                }
                closeDialog()
            } else {
                return false
            }
        })
    }
    const addForm = (form)  => {
        createHandle(form).then((data) => {
            if(data.code == 200){
                ElMessage({
                    showClose: true,
                    message: '添加成功',
                    type: 'success',
                })
                closeDialog()
                emit('refreshDataList')
            }

        })
    }
    const updateForm = (form)  => {
        updateHandle(form).then((data) => {
            if(data.code == 200){
                ElMessage({
                    showClose: true,
                    message: '更新成功',
                    type: 'success',
                })
                closeDialog()
                emit('refreshDataList')
            }

        })
    }
    //编辑---初始化数据
    const init = (id) => {
        isShowDalog.value = props.isShow
        getProductTagTreeHandle()
        if(id){
            query.id = id
            detailHandle({id:id}).then(data => {
                query.name = data.data.name
                query.signature = data.data.signature
                query.mobile = data.data.mobile
                query.email = data.data.email
                query.account = data.data.account
            })
        }else{
            console.log('无id')
        }
    }
    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
        ['blockquote', 'code-block'], //引用，代码块
        [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
        [{ 'list': 'ordered' }, { 'list': 'bullet' }], //列表
        [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
        [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
        [{ 'direction': 'rtl' }], // 文本方向
        [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], //几级标题
        [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
        [{ 'font': [] }], //字体
        [{ 'align': [] }], //对齐方式
        ['clean'], //清除字体样式
        ['image'] //上传图片、上传视频
    ];
    const modules = {
        name: 'imageUploader',
        modules:{
            toolbar:{
                container:toolbarOptions,
                handlers:{
                    "image":file => {
                        //此处需要input输入框和文本编辑器配合使用
                        //出发点击事件
                        document.getElementById('fileToRichText').click()
                        //监听input框变化
                        document.getElementById('fileToRichText').addEventListener('change', uploadImage);
                    }
                }
            }
        }
    }
    function uploadImage(){
        var fileInput = document.getElementById('fileToRichText');
        var file = fileInput.files[0];
        var formData = new FormData();
        // 将文件添加到FormData对象
        formData.append('file', file);
        upload(formData).then(data=>{
            console.log("上传成功")
            let quill = quillRef.value.getQuill()
            let length = 0
            if(quill.getSelection() != null){
                length = quill.getSelection().index
            }
            quill.insertEmbed(length,'image',data.data);
            quill.setSelection(length+1)
        })
    }
    let quillRef = ref(null)
    function getImage(val){
        query.imgurl = val[0]
    }
    //定义父组件需要调用的方法
    defineExpose({
        init
    })
    onMounted( () => {

    })
    const emit = defineEmits(["closeDialog","refreshDataList"])
</script>

<style lang="scss" scoped>
    .title{
        background: #ededed;
        padding: 10px 0;
        margin-bottom: 20px;
        p{
            width: 98%;
            margin: 0 auto;
        }
    }
    .editor{
        width: 100%;
    }
</style>
